const SUGGESTION_RESPONSE = {
  CREATE_REQUEST:'CREATE_SUGGESTION_RESPONSE_REQUEST',
  CREATE_SUCCESS: 'CREATE_SUGGESTION_RESPONSE_SUCCESS',
  CREATE_FAILURE: 'CREATE_SUGGESTION_RESPONSE_FAILURE',
  FETCH_REQUEST: 'FETCH_SUGGESTION_RESPONSE_REQUEST',
  FETCH_SUCCESS: 'FETCH_SUGGESTION_RESPONSE_SUCCESS',
  FETCH_FAILURE:  'FETCH_SUGGESTION_RESPONSE_FAILURE',
}

export default SUGGESTION_RESPONSE;